import ClipLoader from 'react-spinners/ClipLoader';
import React from 'react';
import './loading.css'
import { MoonLoader } from 'react-spinners';

export const Loading = () => {
    return (
        <div className={'loading-app'}>
            <MoonLoader
                color={ '#1c53ec' }
                loading={ true }
                size={ 100 }
                aria-label="Loading Spinner"
                data-testid="loader"
            />
        </div>
    )
}
